import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DocumentoRecibidoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    guardarDocumentoCompra(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: documento_recibidoDTOInputType) {
          documento_recibido {
            recibirDocumentoCompra(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                cabecera{
                  rut_emisor
                  folio
                  tipo_dte_codigo
                  bodega_codigo
                  id_doc
                  id_xml
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documento_recibido.recibirDocumentoCompra;
            callback({ mensajes, respuesta });
        });
    }
}
DocumentoRecibidoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DocumentoRecibidoService_Factory() { return new DocumentoRecibidoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DocumentoRecibidoService, providedIn: "root" });
